import { useMemo } from 'react'

import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'
import { formatDate, isDateValid } from 'utils/datetime'
import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { useAPIPelaksanaanDocumentPreparation } from 'api/kinerja/useAPIKinerja'

import type { LangkahObservasiCardProps } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahRincianObservasiCard = (
  props: LangkahObservasiCardProps
) => {
  const CURRENT_STEP = 'OBSERVATION_IMPLEMENTATION'
  const currentStateOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[props?.state]?.order ?? -1
  const stateOrder = PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order
  const shouldShowDate = props.state === CURRENT_STEP

  const { data: documentData, isLoading } =
    useAPIPelaksanaanDocumentPreparation({
      opts: {
        useErrorBoundary: false,
        enabled: currentStateOrder >= stateOrder,
      },
    })

  const observationDate = documentData?.data?.detail?.observationDate
  const formattedObservationDate = isDateValid(observationDate)
    ? formatDate(observationDate)
    : ''

  const overrideState = useMemo(() => {
    if (currentStateOrder > stateOrder) return 'done'
    if (currentStateOrder === stateOrder) return 'unlocked'
    return 'locked'
  }, [currentStateOrder, stateOrder])

  return (
    <LangkahObservasiCard
      {...props}
      isLoading={isLoading}
      overrideState={overrideState}
      description={
        shouldShowDate && formattedObservationDate
          ? `${props.description}: <strong>${formattedObservationDate}.</strong>`
          : `${props.description}.`
      }
    />
  )
}
